var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"gmp-page gmp-page--no-newsletter"},[_c('PL_scondHero'),_c('PL_highLights',{attrs:{"clientWidth":_vm.clientWidth}}),_c('PL_twoTout'),_c('div',[_vm._v("Distributor")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }